import React, {FC} from "react"

import {Checkbox} from "@irati/ui/src/FormItem"
import Flex from "@irati/ui/src/Flex"
import {ValidationProps} from "@irati/utils/validation/Input"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"
import {Body} from "@irati/ui/src/Typography"
import auth from "@irati/auth"
import styled from "styled-components"

export const PayByWalletCard = styled.div`
  padding-top: ${({theme}) => theme.spacing.oneAndHalf};
  padding-bottom: ${({theme}) => theme.spacing.oneAndHalf};
  border: 1px solid ${({theme}) => theme.colors.greys.disabled};
  border-radius: ${({theme}) => theme.spacing.half};
  margin-bottom: ${({theme}) => theme.spacing.eleven};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({theme}) => theme.spacing.two};
`

interface Props extends ValidationProps<string> {
  id?: string
  value: boolean
  availableBalance: number
  remainingBalance: number
  currency: string
  amount: number
  onChange: (value: boolean) => void
}

const PayByWalletCheckBox: FC<Props> = (props: Props) => {
  const {value, onChange, currency, availableBalance = 0, amount} = props
  if (!auth.apps("wallet.users") || availableBalance <= 0) {
    return null
  }
  const totalToBePaid = amount >= availableBalance ? availableBalance : amount

  return (
    <PayByWalletCard>
      <Spacing>
        <Checkbox
          name="payByWalletCheckbox"
          id="platform.wallet.components.payByWallet.checkbox.label"
          checked={value}
          onChange={() => onChange(!value)}>
          <Flex inline direction="row" alignItems="center">
            <div>
              <Body small>
                <FormattedMessage id="platform.wallet.components.payByWallet.checkbox.label" />
              </Body>
              {value && (
                <Body small>
                  <FormattedMessage
                    id="platform.wallet.components.payByWallet.remainingCashbackBalance"
                    values={{
                      amount: <FormattedCurrency value={totalToBePaid} currency={currency} />,
                      balance: <FormattedCurrency value={availableBalance} currency={currency} />
                    }}
                  />
                </Body>
              )}
            </div>
          </Flex>
        </Checkbox>
      </Spacing>
    </PayByWalletCard>
  )
}

export default PayByWalletCheckBox
